import { QuantityInputItem } from './types';

/**
 * Creates a complete list showing all product tickets,
 * with unavailable ones marked as disabled.
 *
 * The merge preserves the order from defaultItems (product order),
 * and replaces disabled placeholders with available items when they exist.
 */
export const mergeWithDefaultItems = (
    availableItems: readonly QuantityInputItem[],
    defaultItems: readonly QuantityInputItem[],
): QuantityInputItem[] => {
    const availableById = new Map(availableItems.map((item) => [item.id, item]));

    return defaultItems.map((defaultItem) => {
        const availableItem = availableById.get(defaultItem.id);
        // Use available if exists, else default (disabled)
        return availableItem ?? defaultItem;
    });
};

export const hasUnavailableItems = (items: readonly QuantityInputItem[]): boolean => {
    return items.some((item) => item.disabled);
};
